import type { TextManager } from '@wix/wix-richtext';
import { createThemedAction } from '../utils/themedAction';
import type { ThemedActionCreationData } from '../utils/textAction';
import { constants as textControlsConstants } from '../index';

export const fontWeight = {
  Bold: 'bold',
  Normal: 'normal',
  W_100: '100',
  W_200: '200',
  W_300: '300',
  W_400: '400',
  W_500: '500',
  W_600: '600',
  W_700: '700',
  W_800: '800',
  W_900: '900',
} as const;
export type FontWeight = (typeof fontWeight)[keyof typeof fontWeight];

const fontWeightSet = new Set(Object.values(fontWeight));

export const isFontWeight = (value: any): value is FontWeight => {
  return fontWeightSet.has(value);
};

const fontWeightActionCreationData: Readonly<ThemedActionCreationData<string>> =
  {
    execCommand: (textManager, actionInput) => {
      textManager.commands.fontWeight(actionInput);
    },
    getWixRichTextCommandState: (textManager: TextManager) => {
      const fontWeight = textManager.getCommandsStates().fontWeight;

      if (fontWeight === textControlsConstants.CK_OFF) {
        return;
      }
      const fontWeightAsString = `${fontWeight}`;

      if (isFontWeight(fontWeightAsString)) {
        return fontWeightAsString;
      }
    },
    execRevertCommand: (textManager) => {
      textManager.commands.fontWeight('');
    },
    createUpdatedStyleProperties: (fontWeight) => ({ fontWeight }),
    getPropertyValue: (styleProperties) => styleProperties.fontWeight,
    getThemeValue: (theme) => {
      if (theme.bold) {
        return fontWeight.Bold;
      }

      if (theme.weight) {
        return theme.weight as FontWeight;
      }

      return fontWeight.Normal;
    },
  };

export const fontWeightAction = createThemedAction(
  fontWeightActionCreationData,
);
